import type { AcquirerToVirtualDto } from "src/app/features/Acquirer/types/subTypes/AcquirerToVirtualDto";
import type { AcquirerToVirtualEntity } from "src/app/features/Acquirer/types/subTypes/AcquirerToVirtualEntity";

export const AcquirerToVirtualEntityToDto = (entity: Readonly<AcquirerToVirtualEntity>): AcquirerToVirtualDto => ({ ...entity });
